import { createFileRoute } from '@tanstack/react-router';
import { RelatorioCadastroControleLotes } from '@/features/relatorio/page/cadastro/controle-lotes/RelatorioCadastroControleLotes';

export const Route = createFileRoute('/a/relatorio/cadastro/controle-lotes')({
    component: RelatorioCadastroControleLotes,
});
